import React, { createContext, useContext, useState } from 'react';

const STORAGE_KEY = 'soil_testing_chat_drawer_open';

const ChatDrawerContext = createContext({
  chatOpen: false,
  setChatOpen: () => {},
});

export const ChatDrawerProvider = ({ children }) => {
  const [chatOpen, setChatOpenState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });

  const setChatOpen = (isOpen) => {
    setChatOpenState(isOpen);
    try {
      localStorage.setItem(STORAGE_KEY, String(isOpen));
    } catch (e) {
      console.error('Failed to save drawer state', e);
    }
  };

  return (
    <ChatDrawerContext.Provider value={{ chatOpen, setChatOpen }}>
      {children}
    </ChatDrawerContext.Provider>
  );
};

export const useChatDrawer = () => useContext(ChatDrawerContext);

export default ChatDrawerContext;
